const initialState = {
  userInfo: null,
  token: null,
  voteComplete: false
}

export default initialState;
